export default "__VITE_ASSET__BuSb4ad4__"